<template>
  <div class="faq-item">
    <div class="faq-item-title" @click="visible = !visible">
      <h3 v-if="faq.question">
        {{ faq.question }}
      </h3>
      <b-icon v-if="collapsable" class="collapsable-icon" :icon="visible ? 'chevron-up' : 'chevron-down'" :aria-label="$t('actions.readAnswer')" />
    </div>
    <p v-if="faq.answer" v-show="isVisible">
      {{ faq.answer }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ProductFaq',
  props: {
    faq: {
      type: Object,
      default: null
    },
    collapsable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: true
    }
  },
  computed: {
    isVisible () {
      if (this.collapsable) {
        if (this.visible) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  },
  created () {
    this.visible = !this.collapsable
  }
}
</script>

<style lang="scss" scoped>
.faq-item-title {
  display: flex;
  justify-content: space-between;
  &:hover {
    cursor: pointer;
    .collapsable-icon {
      color: #666666;
    }
  }
}
.collapsable-icon {
  margin-top: 3px;
  color: #c4c4c4;
}
</style>
